import IconHVACUnit, {
	IconHVACUnitProps as _IconHVACUnitProps,
} from './IconHVACUnit';

export { IconHVACUnit };
export type IconHVACUnitProps = _IconHVACUnitProps;
